import { DocumentFileDto } from './history.state';
import { FiltersKeyEnum } from '../../../shared/enums/filtersKey.enum';
import { EvaluationApplicationPayload, EvaluationSendForSignPayloadModel } from '../../../shared/models/evaluation-model';

export class GetDocumentHistory {
  static readonly type = '[History] Get document history';

  constructor(public uid: string) {}
}

export class RefreshDocumentHistory {
  static readonly type = '[History] Refresh document history';
}

export class CreateHistoryItem {
  static readonly type = '[History] Create Item';

  constructor(
    public documentTypeIds: number[],
    public allDocuments: boolean,
    public isRemoveAllDocuments: boolean,
  ) {}
}

export class MakeStartedAO {
  static readonly type = '[History] Create Started AO';

  constructor(public uid: string) {}
}

export class PrintHistoryDoc {
  static readonly type = '[History] Print document';

  constructor(
    public historyId?: number,
    public openInTab = true,
  ) {}
}

export class OpenHistorySign {
  static readonly type = '[History] Open sign popup';

  constructor(
    public documentTypeIds: number[],
    public allDocuments: boolean,
    public isRemoveAllDocuments: boolean,
  ) {}
}

export class SignHistoryDocs {
  static readonly type = '[History] Sign docs';

  constructor(public sign: string) {}
}

export class DeleteHistoryItem {
  static readonly type = '[History] Delete history item';

  constructor(public historyItemId: number) {}
}

export class UploadDocument {
  static readonly type = '[History] Upload document';

  constructor(public data: DocumentFileDto) {}
}

export class OpenUploadPopup {
  static readonly type = '[History] Open upload popup';

  constructor(public row: any) {}
}

export class HistorySendEmail {
  static readonly type = '[History] Send email';

  constructor(
    public allDocuments: boolean,
    public isRemoveAllDocuments: boolean,
  ) {}
}

export class HistorySendSms {
  static readonly type = '[History] Send sms';

  constructor(
    public number: string,
    public documentTypeIds: number[],
    public allDocuments: boolean,
    public isRemoveAllDocuments: boolean,
  ) {}
}

export class HistorySync {
  static readonly type = '[History] Sync documents';

  constructor(public documentIds: string[]) {}
}

export class ChangeCreatedAt {
  static readonly type = '[History] Change createdAt';

  constructor(
    public documentHistoryId: number,
    public newDate: string,
    public dateProperty: string,
  ) {}
}

export class GetEmployeeAttachmentsList {
  static readonly type = '[History] Get attachments list (admin)';

  constructor(
    public employeeId: string,
    public filters?: { order: string; dir: 'asc' | 'desc'; perPage?: number },
  ) {}
}

export class UploadEmployeeAttachment {
  static readonly type = '[History] Upload attachment (admin)';

  constructor(
    public title: string,
    public file: any,
  ) {}
}

export class AddAttachmentComment {
  static readonly type = '[History] Add comment to employee attachment';

  constructor(
    public attachmentId: string,
    public comment: string,
  ) {}
}

export class EditAttachment {
  static readonly type = '[History] Update attachment';

  constructor(
    public attachmentId: string,
    public body: { title: string },
  ) {}
}

export class DeleteAttachment {
  static readonly type = '[History] Delete attachment';

  constructor(public attachmentId: number | string) {}
}

export class DownloadAttachment {
  static readonly type = '[History] Download attachment';

  constructor(public attachmentIds: number | string | string[]) {}
}

export class DownloadAttachments {
  static readonly type = '[History] Download multiple attachments';

  constructor(
    public attachmentIds: string[],
    public uid?: string,
  ) {}
}

export class RefreshDocumentAttachments {
  static readonly type = '[History] Refresh employee attachments';

  constructor(public keyFilters: FiltersKeyEnum) {}
}

export class SyncAttachments {
  static readonly type = '[History] HhaExchangeSync attachments';

  constructor(public attachmentId: string) {}
}

export class SetHistoryPage {
  static readonly type = '[History] Set page';

  constructor(public page: number) {}
}

export class SetEmployeeAttachmentPage {
  static readonly type = '[History] Set attachment page';

  constructor(public page: number) {}
}

export class SetSpecialStatus {
  static readonly type = '[History] Set special status';

  constructor(
    public id: number,
    public statusId: number,
  ) {}
}

export class ResetDocumentFilters {
  static readonly type = '[History] Reset document filters';
}

export class SetPerPage {
  static readonly type = '[History] Set perPage';

  constructor(public perPage: number) {}
}

export class SetUID {
  static readonly type = '[History] SetUID';

  constructor(public uid: string) {}
}

export class SetUIDWithoutRequest {
  static readonly type = '[History] SetUIDWithoutRequest';

  constructor(public uid: string) {}
}

export class EnableDatatableLoading {
  static readonly type = '[History] EnableLoading';
}

export class SetMandatoryAttachmentEmployee {
  static readonly type = '[History] Set mandatory attachment';

  constructor(
    public uid: string,
    public idAttachments: number,
  ) {}
}

export class GetEmployeeEvaluationsList {
  static readonly type = '[History] Get Employee Evaluations List';

  constructor(public keyFilters: FiltersKeyEnum) {}
}

export class GetEmployeeEvaluationsTypes {
  static readonly type = '[History] Get Employee Evaluations Types';
}

export class GetEmployeeEvaluationsStatuses {
  static readonly type = '[History] Get Employee Evaluations Statuses';
}

export class AddEvaluationApplication {
  static readonly type = '[History] Add Evaluation Application';

  constructor(
    public payload: EvaluationApplicationPayload,
    public uid: string,
  ) {}
}

export class UpdateEmployeeEvaluation {
  static readonly type = '[History] Update Employee Evaluation';

  constructor(
    public payload: EvaluationApplicationPayload,
    public uid: string,
    public evaluationId: string,
  ) {}
}

export class DeleteEmployeeEvaluation {
  static readonly type = '[History] Delete Employee Evaluation';

  constructor(
    public uid: string,
    public evaluationId: string,
  ) {}
}

export class GetEmployeeEvaluationPdf {
  static readonly type = '[History] Get Employee Evaluation Pdf';

  constructor(
    public uid: string,
    public evaluationId: string,
    public isDownloadFile = false,
  ) {}
}

export class SendEmployeeEvaluationToHha {
  static readonly type = '[History] Send Employee Evaluation To HHA';

  constructor(
    public uid: string,
    public evaluationId: string,
  ) {}
}

export class GetEmployeeEvaluationById {
  static readonly type = '[History] Get Employee Evaluation By Id';

  constructor(
    public uid: string,
    public evaluationId: string,
  ) {}
}

export class ClearEmployeeEvaluations {
  static readonly type = '[History] Clear Employee Evaluations';
}

export class SendEmployeeEvaluationForSign {
  static readonly type = '[History] Send Employee Evaluation For Sign';

  constructor(
    public uid: string,
    public evaluationId: string,
    public payload: EvaluationSendForSignPayloadModel,
  ) {}
}

export class SetEmployeeEvaluationSignedStatus {
  static readonly type = '[History] Set Employee Evaluation Signed Status';

  constructor(
    public uid: string,
    public evaluationId: string,
  ) {}
}

export class SignEmployeeEvaluation {
  static readonly type = '[History] Sign Employee Evaluation';

  constructor(
    public uid: string,
    public evaluationId: string,
    public payload: { employeeSignature: 'string'; supervisorSignature: 'string'; key: string },
  ) {}
}

export class SignMyEmployeeEvaluation {
  static readonly type = '[History] Sign My Employee Evaluation';

  constructor(
    public evaluationId: string,
    public payload: { employeeSignature: string; key: string },
  ) {}
}

export class SetEmployeeEvaluationCompletedStatus {
  static readonly type = '[History] Set Employee Evaluation Completed Status';

  constructor(
    public uid: string,
    public evaluationId: string,
  ) {}
}

export class ChangeEmployeeEvaluationPeriod {
  static readonly type = '[History] Change Employee Evaluation Period';

  constructor(
    public uid: string,
    public evaluationId: string,
    public payload: { ratingPeriodFrom: string; ratingPeriodTo: string },
  ) {}
}

export class ChangeEmployeeEvaluationEmployeeSignedAtDate {
  static readonly type = '[History] Change Employee Evaluation Employee Signed At Date';

  constructor(
    public uid: string,
    public evaluationId: string,
    public payload: { signedAt: string },
  ) {}
}

export class ChangeEmployeeEvaluationSupervisorSignedAtDate {
  static readonly type = '[History] Change Employee Evaluation Supervisor Signed At Date';

  constructor(
    public uid: string,
    public evaluationId: string,
    public payload: { signedAt: string },
  ) {}
}

export class ChangeEmployeeEvaluationSendForSignAtDate {
  static readonly type = '[History] Change Employee Evaluation Send For Sign At Date';

  constructor(
    public uid: string,
    public evaluationId: string,
    public payload: { sendForSignAt: string },
  ) {}
}
